import { useEffect, useState } from 'react'
import { GoogleMap, Marker } from '@react-google-maps/api'

interface Props {
  address: string
  zipCode: number
  city: string
  height: number
}

function GoogleMapComp({ address, zipCode, city, height }: Props) {
  const [latitude, setLatitude] = useState(0)
  const [longitude, setLongitude] = useState(0)

  useEffect(() => {
    const geocoder = new window.google.maps.Geocoder()
    geocoder.geocode(
      {
        address: `${address}, ${zipCode} ${city}`,
      },
      (results: any, status) => {
        if (status === window.google.maps.GeocoderStatus.OK) {
          setLatitude(results[0].geometry.location.lat())
          setLongitude(results[0].geometry.location.lng())
        }
      },
    )
  }, [address])
  return (
    <GoogleMap
      mapContainerStyle={{ height: `${height}px`, width: '100%' }}
      center={{ lat: latitude, lng: longitude }}
      zoom={13}
    >
      <></>
      <Marker position={{ lat: latitude, lng: longitude }} />
    </GoogleMap>
  )
}
export default GoogleMapComp
